const toBoolean = (value) => {
  if (value === true) {
    return true;
  }

  return (
    String(value || '')
      .trim()
      .toLowerCase() === 'true'
  );
};

const isWhitelistedForCompany = ({ whitelistedCompanies, companyId }) => {
  const safeCompanyId = String(companyId || '').trim();

  if (!safeCompanyId || !Array.isArray(whitelistedCompanies)) {
    return false;
  }

  return whitelistedCompanies.some((candidateCompanyId) => String(candidateCompanyId || '').trim() === safeCompanyId);
};

export const isPieveAppVisible = ({ app, companyId, isMindcloudAdmin = false } = {}) => {
  if (!toBoolean(app?.showOnPieve)) {
    return false;
  }

  const whitelistedCompanies = Array.isArray(app?.whitelistedCompanies) ? app.whitelistedCompanies : [];

  return !toBoolean(app?.hidden) || isMindcloudAdmin === true || isWhitelistedForCompany({ whitelistedCompanies, companyId });
};
